import { useEffect, useState } from "react";

import {
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  message,
  Popconfirm,
  Space,
  Table,
  Upload,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { NewModal } from "../NewModal";
import { useCompanies } from "../../hooks/useCompanies";
import { useUser } from "../../hooks/useUsers";
import FormItem from "antd/lib/form/FormItem";
import Icon from "@ant-design/icons/lib/components/Icon";

interface IRowItem {
  id: string;
  name: string;
  description: string;
  document: string;
  logo: string;
  primary_color: string;
  secondary_color: string;
}

interface IEditCompany extends IRowItem {

}

export function CompaniesTable() {
  const {
    fetchRoles
  } = useUser();
  const {
    companies,
    loading,
    fetchCompanies,
    total,
    updateCompany,
    deleteCompany,
    handleModalVisible,
  } = useCompanies();
  const currentRoute = useParams();
  const navigate = useNavigate();

  const [visibleEdit, setVisibleEdit] = useState(false);
  const [page, setPage] = useState<number>(Number(currentRoute.page));
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState<string>("name");
  const [formDefault, setFormDefault] = useState<IEditCompany>({} as IEditCompany);
  const [selected, setSelected] = useState<IRowItem[]>([]);
  const [search, setSearch] = useState<string>("");
  const data = companies;

  const handleOkEdit = async () => {
    const status: any = await updateCompany(formDefault.id, {
      name: formDefault.name,
      description: formDefault.description,
      document: formDefault.document,
      logo: formDefault.logo,
      primary_color: formDefault.primary_color,
      secondary_color: formDefault.secondary_color,
    });

    if (status?.status === 200) message.success("Editado");
    else message.error("Falha!");
  };

  const handleCancelEdit = () => {
    setVisibleEdit(false);
  };

  const confirm = async (record: any) => {
    const index = data.indexOf(record);

    const status: any = await deleteCompany(companies[index].id);

    if (status?.response?.status === 500 || status?.response?.status === 406) {
      message.warning("Falha!");
    } else {
      message.success("Excluído!");
    }

    fetchCompanies(page, order, orderBy);
    fetchRoles();
  };

  useEffect(() => {
    if (search !== "") {
      fetchCompanies(page, order, orderBy, search);
    } else {
      fetchCompanies(page, order, orderBy);
    }
  }, [page, search]);

  function onChange(pagination: any, filters: any, sorter: any, extra: any) {
    if (!sorter.field) return;

    if (sorter.order === "descend") {
      if (search !== "") {
        fetchCompanies(page, "desc", sorter.field, search);
        setOrder("desc");
        setOrderBy(sorter.field ? sorter.field : "name");
      } else {
        fetchCompanies(page, "desc", sorter.field);
        setOrder("desc");
        setOrderBy(sorter.field ? sorter.field : "name");
      }
    } else {
      if (search !== "") {
        fetchCompanies(page, "asc", sorter.field, search);
        setOrder("asc");
        setOrderBy(sorter.field ? sorter.field : "name");
      } else {
        fetchCompanies(page, "asc", sorter.field);
        setOrder("asc");
        setOrderBy(sorter.field ? sorter.field : "name");
      }
    }
  }

  const FormEdit = ({ id, name, description, document, logo, primary_color, secondary_color }: IEditCompany) => {
    const [logoTemp, setLogoTemp] = useState<any>(logo);

    return (
      <Form
        onFinish={async (form) => {
          setVisibleEdit(false);

          const status: any = await updateCompany(id, form);

          if (status?.status === 200) message.success("Editado!");
          else message.error("Falha!");

          fetchCompanies(page, order, orderBy);
          fetchRoles();
        }}
      >
        <Form.Item
          name="name"
          label="Nome"
          style={{
            marginBottom: "25px",
          }}
          rules={[
            {
              required: true,
              message: "Este campo é obrigatório!",
            },
          ]}
          initialValue={name}
        >
          <Input
            maxLength={50}
            placeholder="Nome da empresa!"
            defaultValue={name}
          />
        </Form.Item>

        <Form.Item
          name="description"
          label="Descrição"
          style={{
            marginBottom: "25px",
          }}
          rules={[
            {
              required: true,
              message: "Este campo é obrigatório!",
            },
          ]}
          initialValue={description}
        >
          <Input maxLength={50} placeholder="Descrição" defaultValue={description} />
        </Form.Item>

        <Form.Item
          name="logo"
          label="Logo"
          style={{
            marginBottom: "25px",
          }}
          // rules={[
          //   {
          //     required: true,
          //     message: "Este campo é obrigatório!",
          //   },
          // ]}
        >
          <Upload
              accept=".jpg, .jpeg, .png"
              showUploadList={false}
              beforeUpload={file => {
                  const reader = new FileReader();

                  reader.onload = e => {
                      console.log(e?.target?.result);
                      setLogoTemp(e?.target?.result);
                  };
                  reader.readAsDataURL(file);

                  // Prevent upload
                  return false;
              }}
          >
            {
              logoTemp && <img src={logoTemp} alt="logo" style={{ width: '100px' }} />
            }
            <Button style={{ marginLeft: '10px' }}>
              <Icon type="upload" /> Selecionar imagem
            </Button>
          </Upload>
        </Form.Item>

        <FormItem
          name="document"
          label="CNPJ"
          style={{
            marginBottom: "25px",
          }}
          rules={[
            {
              required: true,
              message: "Este campo é obrigatório!",
            },
          ]}
          initialValue={document}
        >
          <Input maxLength={14} placeholder="CNPJ" defaultValue={document} />
        </FormItem>

        <FormItem
          name="primary_color"
          label="Cor primária"
          style={{
            marginBottom: "25px",
          }}
          rules={[
            {
              required: true,
              message: "Este campo é obrigatório!",
            },
          ]}
          initialValue={primary_color}
        >
          <Input type="color" defaultValue={primary_color} />
        </FormItem>

        <FormItem
          name="secondary_color"
          label="Cor secundária"
          style={{
            marginBottom: "25px",
          }}
          rules={[
            {
              required: true,
              message: "Este campo é obrigatório!",
            },
          ]}
          initialValue={secondary_color}
        >
          <Input type="color" defaultValue={secondary_color} />
        </FormItem>

        <FormItem style={{ paddingLeft: "63%" }}>
          <Button type="primary" htmlType="submit">
            Salvar
          </Button>
          <Button onClick={() => setVisibleEdit(false)}>Cancelar</Button>
        </FormItem>
      </Form>
    );
  }

  const columns: any = [
    {
      title: "Nome",
      dataIndex: "name",
      key: "name",
      sorter: (a: IRowItem, b: IRowItem) => a.name.localeCompare(b.name),
      filterDropdown: () => (
        <div>
          <Input
            maxLength={50}
            placeholder="Buscar nome"
            onChange={({ target }) => setSearch(target.value)}
            style={{
              width: "9rem",
            }}
          />
        </div>
      ),
      filterIcon: (
        <SearchOutlined
          style={{
            fontSize: 17,
          }}
        />
      ),
    },
    {
      title: "CNPJ",
      dataIndex: "document",
      key: "document",
      sorter: (a: IRowItem, b: IRowItem) => a.document.localeCompare(b.document),
    }
  ];

  columns.push({
    title: "Ações",
    key: "action",
    render: (text: string, record: IRowItem) => (
      <Space size="middle">
        <a
          style={{
            color: "#F7CD11",
          }}
          onClick={() => {
            const defaultValue = companies.filter(
              (item) => item.id === record.id
            )[0];
            setFormDefault({...defaultValue});
            setVisibleEdit(true);
          }}
        >
          Editar
        </a>

        <Popconfirm
          title="Você tem certeza?"
          onConfirm={() => confirm(record)}
          okText="Sim"
          cancelText="Não"
        >
          <a
            style={{
              color: "#ff0000",
            }}
          >
            Deletar
          </a>
        </Popconfirm>
      </Space>
    ),
  });

  return (
    <div>
      <Space style={{ marginBottom: 16, marginTop: 15 }}>
        <Button onClick={() => handleModalVisible(true)}>Nova empresa</Button>
      </Space>
      <Table
        showSorterTooltip={{ title: "Clique para ordenar" }}
        dataSource={selected.length > 0 ? selected as any : data as any}
        columns={columns}
        rowKey={(item) => item.email}
        onChange={onChange}
        loading={loading}
        pagination={{
          position: ["bottomRight"],
          pageSize: 7,
          current: Number(page),
          total: total,
          onChange: (pageAux) => {
            navigate(`/companies/${pageAux}`);
            setPage(pageAux);
          },
        }}
      />

      <NewModal
        buttonModalText={"Editar"}
        visible={visibleEdit}
        handleCancel={handleCancelEdit}
        handleOk={handleOkEdit}
        title="Editar empresa"
      >
        <FormEdit
          id={formDefault.id}
          name={formDefault.name}
          description={formDefault.description}
          document={formDefault.document}
          logo={formDefault.logo}
          primary_color={`#${formDefault.primary_color}`}
          secondary_color={`#${formDefault.secondary_color}`}
        />
      </NewModal>
    </div>
  );
}
